import { render } from "./CustomSelect.vue?vue&type=template&id=ba182cec&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=ba182cec&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba182cec"]])

export default __exports__